import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import AuthService from "./AuthService";

function PrivateRoute({ allowedAccessTypes, allowedRoles }) {
  if (!AuthService.isAuthenticated()) return <Navigate to="/" replace />;
  const type = AuthService.getAccessType();
  if (allowedAccessTypes && !allowedAccessTypes.includes(type)) {
    const target = type === "POLICY_HOLDER" ? "/policyholder/dashboard" : type === "AGENT" ? "/agent/dashboard" : type === "PARTNER" ? "/partner/ecosure" : "/notifications";
    return <Navigate to={target} replace />;
  }
  if (allowedRoles) {
    const role = String(
      AuthService.getCurrentUser()?.role || ""
    ).trim().toUpperCase();
    if (!allowedRoles.includes(role)) {
      return <Navigate to="/notifications" replace />;
    }
  }
  return <Outlet />;
}
export default PrivateRoute;
